export const clientEquipmentUsageDeclarationsHistoryColumns = [
  { value: 'transaction_id', label: 'Transação' },
  { value: 'author', label: 'Autor' },
  { value: 'product_category', label: 'Serviço' },
  { value: 'created_at', label: 'Data' },
  { value: 'value', label: 'Últ. Consumo Informado' },
  { value: 'reason', label: 'Justificativa' },
  { value: 'actions', label: 'Ações', className: 'w-11' },
];
